export default __webpack_public_path__ + "img/a4ef33e9c211c2c016164419a6a5b27a.svg";